import { parseLanding, type LandingKind, type LandingPageData } from '@/lib/landingFormat';

/**
 * City and industry pages, one markdown file each under ./<kind>/<slug>.md.
 * The folder name must match the file's `kind`. The prerenderer reads the same
 * files from disk, so adding a file adds the page, its HTML and its sitemap entry.
 */
const files = import.meta.glob('./*/*.md', { query: '?raw', import: 'default', eager: true }) as Record<string, string>;

export const landingPages: LandingPageData[] = Object.entries(files)
  .map(([file, src]) => {
    const page = parseLanding(src, file);
    if (!file.startsWith(`./${page.kind}/`)) throw new Error(`landing ${file}: kind "${page.kind}" is in the wrong folder`);
    return page;
  })
  .sort((a, b) => (a.city || a.industry || '').localeCompare(b.city || b.industry || ''));

export const getLanding = (kind: LandingKind, slug: string) =>
  landingPages.find((p) => p.kind === kind && p.slug === slug);

export const landingsOf = (kind: LandingKind) => landingPages.filter((p) => p.kind === kind);
